import React, {useEffect, useState } from "react";
import
  PropTypes
from 'prop-types';
import * as Constants from '../../../components/common/Constants'
import { MainContainer } from "../registration/RegistrationLayout.styled";
import businessLogo from '../../../images/plain-business-logo.svg';
import { PrimaryButton, RegularText, RegularUnderlinedText, SecondaryButton, XXLBoldText } from "../input/TextField.styles";
import { TextField } from "../input";
import ProfileService from "../../../services/ProfileService";
import Captcha from "../../../components/common/Captcha";
import { useSelector } from "react-redux";
import { ErrorPage } from "../errorPage/ErrorPage";
import Loader from "../../../components/common/Loader";

export const ForgotUsername = (props) => {
  const [ forgotUsernameDetails, setForgotUsernameDetails ] = useState({});
  const { isCaptchaValidated } = useSelector((state) => ({ isCaptchaValidated: state.isCaptchaValidated }));
  const { captchaResponse } = useSelector((state) => ({ captchaResponse: state.captchaResponse }));
  const [ enableSubmit, setEnableSubmit ] = useState(false);
  const [ isError, setIsError ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState();
  const [ showLoader, setShowLoader ] = useState(false);
  
  useEffect(() => {
    props.setDisplayView({...[], currentDisplay: Constants.FORGET_USERNAME})
  }, []);

  useEffect(() => {
    if (isCaptchaValidated && !forgotUsernameDetails?.isError && forgotUsernameDetails?.value) {
      setEnableSubmit(true);
    } else {
      setEnableSubmit(false);

    }
  }, [isCaptchaValidated, forgotUsernameDetails]);

    
  useEffect(() => {
  }, [forgotUsernameDetails]);

  const emailOnChange = (e) => {
    props.setNotificationAlertDisplay('none');
    if (Constants.EMAIL_REGEX.test(e.target.value) && e.target.value.match(/@/g).length === 1 && e.target.value[e.target.value.length - 1] !== ".") {
      setForgotUsernameDetails({id: e.target.id, isError: false, message: '', value: e.target.value});
    }
    else {                
      setForgotUsernameDetails({id: e.target.id, isError: true, message: 'Please enter a valid email address.', value: e.target.value});
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const submit = (e) => {
    e.preventDefault();
    props.setEmail(forgotUsernameDetails?.value);
    props.setNotificationAlertDisplay('none');
    setShowLoader(true);
    ProfileService.callForgetUsername(
      captchaResponse,
      forgotUsernameDetails?.value
    )
      .then((response) => {

        if (response.data.result.sentEmail === true) {
          setShowLoader(false)
          props.setIsSuccess(true)
        }
      })
      .catch((error) => {
        setShowLoader(false);

        try {
          if (error.response.status === 400 ) {
            setIsError(true);
            setErrorMessage({heading: 'Oops', messageLine1: 'Unfortunately, you’ve entered the incorrect email.', messageLine2: 'Please try again.'})
          }

          if (error.response.status === 404) {
            setIsError(true);
            setErrorMessage({heading: 'Oops', messageLine1: 'Unfortunately, The email address you’ve entered is not recognized on our system or does not have access.', messageLine2: 'Don’t have access to portal? Please contact our support desk on 082 1940.'})
          }

          if (error.response.status === 500) {
            scrollToTop();
            props.setNotificationAlertDisplay('flex');
            props.setNotificationText('We’re experiencing technical difficulties. Please try again later.');
          }
        } catch (e) {
          scrollToTop();
          props.setNotificationAlertDisplay('flex');
          props.setNotificationText('We’re experiencing technical difficulties. Please try again later.');
        }
      });
  };
  
  return (
    <>
     {
        isError ?
        <ErrorPage
          setIsError={setIsError}
          setErrorMessage={setErrorMessage}
          errorMessage={errorMessage}
        /> :
        <MainContainer>
          { showLoader && 
            <Loader/>
          }

        <img width={'100%'} height={props.imageHeight} src={businessLogo} alt="LOGO" />

        <XXLBoldText>Forgot username?</XXLBoldText>

        <TextField
          inputLabel={'Email'}
          placeholder={'Enter email'}
          onChange={emailOnChange}
          inLineMessage={forgotUsernameDetails?.message}
          isError={forgotUsernameDetails?.isError}
          value={forgotUsernameDetails?.value}
        />
        <Captcha />
        <div style={{
          'display': 'flex',
          'justifyContent': 'center',
          'alignItems': 'center',
          'gap': '16px',
          'alignSelf': 'stretch'}}
        >
          <SecondaryButton onClick={() => {props.setDisplayView({...[], currentDisplay: Constants.LOGIN})}}>
            Go back
          </SecondaryButton>
          <PrimaryButton disabled={!enableSubmit} onClick={submit}>
            Next
          </PrimaryButton>
        </div>
          
        <RegularText>
          Don't have an account?&nbsp;
          <RegularUnderlinedText onClick={() => {props.setDisplayView({...[], currentDisplay: Constants.REGISTER})}}>Register</RegularUnderlinedText>
        </RegularText>
      </MainContainer>
    }
    </>
  );
}

ForgotUsername.propTypes = {
  setDisplayView: PropTypes.func,
  setNotificationAlert: PropTypes.func,
  setIsSuccess: PropTypes.func
};

ForgotUsername.defaultProps = {
  setNotificationAlert: ()=>{},
  setDisplayView: ()=>{},
  setIsSuccess: ()=>{}
};